import script from "./MyOrderOpenList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyOrderOpenList.vue?vue&type=script&setup=true&lang=ts"

import "./MyOrderOpenList.vue?vue&type=style&index=0&id=01bcded2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bcded2"]])

export default __exports__